import { CardOptionContent } from '@framework/form/inputs/card-group/CardOptionContent.tsx';
import {
  type IRadioCardOption,
  RadioCardGroupInput,
} from '@framework/form/inputs/card-group/RadioCardGroupInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { IconTextWrap, IconTextWrapDisabled } from '@tabler/icons-react';
import { useState } from 'react';
import { useWatch } from 'react-hook-form';
import { LabelLayout } from '../../../../Widget.ts';
import { WidgetBlockLabelsLogic } from '../../../WidgetBlockLabelsLogic.ts';

const LABEL_LAYOUT_OPTIONS: IRadioCardOption<LabelLayout>[] = [
  {
    value: LabelLayout.Floating,
    label: (
      <CardOptionContent
        icon={<TbIcon icon={IconTextWrapDisabled} />}
        title="Compatta"
        description="Etichetta compatta, su una sola riga, come negli altri campi del form."
      />
    ),
  },
  {
    value: LabelLayout.Block,
    label: (
      <CardOptionContent
        icon={<TbIcon icon={IconTextWrap} />}
        title="Estesa"
        description="Etichetta a blocco, a piena larghezza con font di dimensione maggiore e su più righe."
      />
    ),
  },
];

/**
 * Selettore della disposizione dell'etichetta (`layout.labelLayout`).
 * Senza valore mostra "Compatta" selezionata ma non scrive nel modello:
 * il valore esplicito viene salvato solo alla prima interazione.
 * Nascosto nelle colonne di tabella (etichetta già nell'intestazione) e
 * negli ambienti senza `ENABLE_WIDGET_BLOCK_LABELS`; con flag spento resta
 * però visibile sui widget già salvati a blocco, altrimenti il valore non
 * sarebbe più reversibile da interfaccia.
 */
export function LabelLayoutConfigInput() {
  const isTableColumn = useWatch({ name: 'layout.isTableColumn' });
  const labelLayout = useWatch({ name: 'layout.labelLayout' });
  // Fissato all'apertura della configurazione: il selettore non deve sparire
  // nel momento in cui si seleziona "Compatta".
  const [openedWithBlockValue] = useState(
    () => labelLayout === LabelLayout.Block,
  );
  const showForSavedValue =
    openedWithBlockValue || labelLayout === LabelLayout.Block;

  if (!WidgetBlockLabelsLogic.isEnabled() && !showForSavedValue) return null;
  if (isTableColumn) return null;

  return (
    <FormItem name="layout.labelLayout" label="Disposizione etichetta">
      <RadioCardGroupInput
        name="layout.labelLayout"
        gridColumns={2}
        options={LABEL_LAYOUT_OPTIONS}
        transformValue={value => value ?? LabelLayout.Floating}
      />
    </FormItem>
  );
}
